import { render, staticRenderFns } from "./CatalogThumb.vue?vue&type=template&id=4e8c6530&scoped=true&"
import script from "./CatalogThumb.vue?vue&type=script&lang=js&"
export * from "./CatalogThumb.vue?vue&type=script&lang=js&"
import style0 from "./CatalogThumb.vue?vue&type=style&index=0&id=4e8c6530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c6530",
  null
  
)

export default component.exports